<template>

  <el-form :model="form" :rules="rules" ref="form">

    <el-form-item prop="formaAtendimento">
      <h3><span style="color: #ff4949">*</span> Como será a forma de atendimento?</h3>

      <el-radio-group size="large" v-model="form.formaAtendimento">
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Atendimento no Local" style="font-weight: normal;"></el-radio></el-col>
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Simples Escritório - Somente ponto de referência" style="font-weight: normal;"></el-radio></el-col>
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Online" style="font-weight: normal;"></el-radio></el-col>
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Outros" style="font-weight: normal;"></el-radio></el-col>
      </el-radio-group>
    </el-form-item>

    <el-form-item prop="tipoEmpresa">
      <h3><span style="color: #ff4949">*</span> Tipo de Empresa</h3>

      <el-radio-group size="large" v-model="form.tipoEmpresa">
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Sociedade (Limitada)" style="font-weight: normal;"></el-radio></el-col>
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Individual Limitada (Eireli)" style="font-weight: normal;"></el-radio></el-col>
        <el-col :span="24" style="margin-bottom: 5px;"><el-radio label="Associações (Condomínios, Igrejas, etc...)" style="font-weight: normal;"></el-radio></el-col>
      </el-radio-group>
    </el-form-item>

    <el-form-item prop="outrasInformacoes">
      <h3>Outras Informações</h3>
      <em>Inserir informações que julgar necessário</em>
      <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" v-model="form.outrasInformacoes"></el-input>
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  props: ['form'],

  data () {
    return {
      rules: {
        formaAtendimento: [
          { required: true, message: 'É obrigatório marcar uma das opções', trigger: 'change' }
        ],
        tipoEmpresa: [
          { required: true, message: 'É obrigatório marcar uma das opções', trigger: 'change' }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Diversos.vue?2d99c0bc